
/*
 * Module Description :  Configure Redux App Store 
 *
 * Revision History
 *
 * Date            Author             SR No          Description of Change
 * ----------      ----------         ------         ----------------------
 * 9-June-2020     Narender Kumar     Release1       Initial commit
 *
 * Copyright (c) aposailor.com.
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of
 * aposailor.com ("Confidential Information").  You shall not
 * disclose such Confidential Information and shall use it only in accordance
 * with the terms of the license agreement you entered into with
 * aposailor.com
 */


import { configureStore } from "@reduxjs/toolkit";
import thunkMiddleware from 'redux-thunk'
import {createLogger} from 'redux-logger';
import rootReducer from './reducers.js'

export default function configureAppStore() {
  const logger = createLogger();
  const store = configureStore({ reducer: rootReducer, middleware: [ logger,thunkMiddleware]})

  if (process.env.NODE_ENV !== 'production' && module.hot) {
    module.hot.accept('./reducers', () => store.replaceReducer(rootReducer))
  }

  return store
}